import {Component, ContentChild, Input, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';

import {MatSort} from '@angular/material/sort';
import {TableColumn, TableColumnType} from '../../../../interfaces/table.interface';
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit, OnDestroy {

  @Input() tableColumns: TableColumn[];
  @Input() tableCssClass: string[];
  @Input() tableData$: Observable<any>;
  @Input() pageSizeOptions: number[] = [10, 50, 100, 250];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ContentChild(TemplateRef, {static: true}) actions: TemplateRef<any>;
  listData: MatTableDataSource<any>;

  tableColumnType = TableColumnType;

  subscriptions: Subscription = new Subscription();

  searchKey: string;
  displayedColumns: string[] = [];

  constructor() { }

  ngOnInit(): void {

    this.tableColumns.forEach( (column) => {
      this.displayedColumns.push(column.keyword);
    });
    this.subscriptions.add(
      this.tableData$.subscribe(data => {
        this.listData = new MatTableDataSource(data);
        this.listData.sort = this.sort;
        this.listData.paginator = this.paginator;
      })
    );

  }

  filterTable() {
    this.listData.filter = this.searchKey.trim().toLowerCase();
  }

  onSearchClear() {
    this.searchKey = '';
    this.filterTable();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
